import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type {
  OrderAcceptResult,
  OrderCenterDetail,
  OrderCenterQuery,
  OrderCenterRow,
  OrderRejectResult
} from '../types/orderCenter';
import type { PageResult } from '../types/result';

const BASE = '/wl/order';

/** 运营端接单中心：外仓供货指令汇聚 + 接单/拒单（演-1）。 */
export function createOrderCenterApi(http: HttpClient) {
  return {
    pending(query: OrderCenterQuery = {}): Promise<PageResult<OrderCenterRow>> {
      return http.request<PageResult<OrderCenterRow>>({ path: `${BASE}/pending`, query: toQuery(query) });
    },

    detail(id: Id): Promise<OrderCenterDetail> {
      return http.request<OrderCenterDetail>({ path: `${BASE}/${id}` });
    },

    accept(id: Id): Promise<OrderAcceptResult> {
      return http.request<OrderAcceptResult>({ path: `${BASE}/${id}/accept`, method: 'POST' });
    },

    reject(id: Id, reason?: string): Promise<OrderRejectResult> {
      return http.request<OrderRejectResult>({ path: `${BASE}/${id}/reject`, method: 'POST', body: { reason } });
    }
  };
}

export type OrderCenterApi = ReturnType<typeof createOrderCenterApi>;
